import { useSession } from '@/auth/useSession';
import { DEFAULT_PAGE_SIZE } from '@/lib/pagination';
import { StudentHome } from '@/routes/_layout/-components/student-home';
import { isAirAdmin, isCoach, isStudent } from '@airreading/common';
import { createFileRoute, Navigate } from '@tanstack/react-router';
import { useMemo } from 'react';

export const Route = createFileRoute('/_layout/')({
  component: Index,
});

function Index() {
  const { actingUser } = useSession();

  const userIsStudent = useMemo(() => isStudent(actingUser), [actingUser]);
  const userIsCoach = useMemo(() => isCoach(actingUser), [actingUser]);
  const userIsAirAdmin = useMemo(() => isAirAdmin(actingUser), [actingUser]);

  if (!(userIsStudent || userIsCoach || userIsAirAdmin)) {
    return <div>Unknown user</div>;
  }
  if (userIsAirAdmin) {
    return <Navigate to="/sessions" search={{ pageIndex: 0, pageSize: DEFAULT_PAGE_SIZE }} replace />;
  }
  if (userIsCoach) {
    return <Navigate to="/my-classes/calendar" replace />;
  }
  return <StudentHome />;
}
